import { createContext, useCallback, useContext, useState } from "react";

/**
 * CheckoutContext — global state for the CheckoutModal.
 * Any component can call `openCheckout({ kind, packageId, planId })` to pop it.
 * The modal itself is rendered once at App root (in App.js).
 */

const CheckoutContext = createContext(null);

export function CheckoutProvider({ children }) {
  const [state, setState] = useState({
    open: false,
    kind: "recharge", // "recharge" | "subscription" | "downgrade"
    packageId: "nxt_500",
    planId: "pro",
  });

  const openCheckout = useCallback((payload = {}) => {
    setState((prev) => ({
      open: true,
      kind: payload.kind ?? "recharge",
      packageId: payload.packageId ?? prev.packageId ?? "nxt_500",
      planId: payload.planId ?? prev.planId ?? "pro",
    }));
  }, []);

  const closeCheckout = useCallback(() => {
    setState((prev) => ({ ...prev, open: false }));
  }, []);

  return (
    <CheckoutContext.Provider value={{ ...state, openCheckout, closeCheckout }}>
      {children}
    </CheckoutContext.Provider>
  );
}

export function useCheckout() {
  const ctx = useContext(CheckoutContext);
  if (!ctx) throw new Error("useCheckout must be used inside CheckoutProvider");
  return ctx;
}
